import { Select as MuiSelect, styled, SelectProps, MenuItem } from '@mui/material'
import React, { FC } from 'react'

import { IsItem } from '../interfaces/IsItem'

const StyledSelect = styled((props: SelectProps) => (
  <MuiSelect disableUnderline variant='standard' {...props} />
))(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid black',
  minHeight: '48px',
  menuPaper: {
    maxHeight: 100,
  },
  padding: theme.spacing(0, 1),
  marginBottom: '3px',
}))

interface Props {
  items: IsItem[]
  [otherProps: string]: any
}

const Select: FC<Props> = ({ items, ...otherProps }) => {
  return (
    <StyledSelect
      {...otherProps}
      inputProps={{
        sx: {
          '&.MuiInput-input:focus': {
            backgroundColor: 'transparent',
          },
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: { backgroundColor: 'white' },
        },
        style: { height: '250px', direction: 'rtl', zIndex: 1000000000 },
      }}
    >
      {items.map((item) => (
        <MenuItem key={item.id} value={item.value}>
          {item.label}
        </MenuItem>
      ))}
    </StyledSelect>
  )
}

export default Select
